import React, { useEffect, useState } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import ProfileInfo from "../profile/profileInfo";
import { NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { baseApiUrl } from "../../../services/api";

function Membre() {
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [forumMembers, setForumMembers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(6);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Récupérer tous les utilisateurs avec leurs rôles
        const rolesResponse = await baseApiUrl.get("/role/liste");
        const rolesData = rolesResponse.data;

        const utilisateursResponse = await baseApiUrl.get("/utilisateur");
        const utilisateursData = utilisateursResponse.data.map(utilisateur => {
          const role = rolesData.find(role => role.id === utilisateur.roleId);
          return { ...utilisateur, roles: role ? [role.libelle] : [] };
        });
        setUtilisateurs(utilisateursData);

        // Récupérer toutes les questions
        const questionsResponse = await baseApiUrl.get("/question/liste");
        const questions = questionsResponse.data;

        // Récupérer toutes les réponses
        const reponsesResponse = await baseApiUrl.get("/reponse/liste");
        const reponses = reponsesResponse.data;

        // Collecter les IDs des utilisateurs qui ont posé des questions
        const questionAuthorIds = questions.map(q => {
          // Gérer les deux cas possibles: utilisateurId direct ou objet utilisateur
          return q.utilisateur ? q.utilisateur.id : q.utilisateurId;
        }).filter(id => id !== undefined && id !== null);

        // Collecter les IDs des utilisateurs qui ont répondu
        const responseAuthorIds = reponses.map(r => r.utilisateur ? r.utilisateur.id : null).filter(id => id !== null);

        // Combiner et déduplicater les IDs
        const participantIds = [...new Set([...questionAuthorIds, ...responseAuthorIds])];
        console.log("Liste des IDs des participants :", participantIds);

        console.log("Questions trouvées:", questions.length);
        console.log("Réponses trouvées:", reponses.length);
        console.log("IDs participants:", participantIds);

        // Filtrer les utilisateurs qui ont participé
        const members = utilisateursData.filter(user => participantIds.includes(user.id));
        console.log("Membres du forum filtrés:", members.length);

        setForumMembers(members);
        setIsLoading(false);
      } catch (error) {
        console.error("Erreur lors du chargement des données:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  // Calculer les informations à afficher sur la page actuelle
  const offset = currentPage * itemsPerPage;
  const currentMembers = forumMembers.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(forumMembers.length / itemsPerPage);

  return (
    <div>
      <Header />
      <div
        className="inner-hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
          padding: "50px 0",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="text-center">
            <h1 style={{ color: "white", fontSize: "36px", marginBottom: "15px" }}>Forums</h1>
            <p style={{ color: "white", fontSize: "16px", maxWidth: "800px", margin: "0 auto" }}>
              Le forum c'est l'espace où chaque acteur peut discuter avec les
              autres auteurs sur des thématiques précises.
            </p>
          </div>
        </div>
      </div>

      <div style={{ background: "#f5f7fa", padding: "50px 0" }}>
        <div className="container">
          {/* Navigation Tabs */}
          <div style={{ marginBottom: "30px", borderBottom: "1px solid #e0e0e0" }}>
            <NavLink
              to="/acceuil/forum"
              style={({ isActive }) => ({
                padding: "12px 25px",
                marginRight: "10px",
                borderRadius: "5px 5px 0 0",
                fontWeight: "500",
                backgroundColor: isActive ? "#4CAF50" : "transparent",
                color: isActive ? "white" : "#333",
                display: "inline-block",
                textDecoration: "none",
                transition: "all 0.3s ease"
              })}
            >
              Forum
            </NavLink>
            <NavLink
              to="/acceuil/membre"
              style={({ isActive }) => ({
                padding: "12px 25px",
                borderRadius: "5px 5px 0 0",
                fontWeight: "500",
                backgroundColor: isActive ? "#4CAF50" : "transparent",
                color: isActive ? "white" : "#333",
                display: "inline-block",
                textDecoration: "none",
                transition: "all 0.3s ease"
              })}
            >
              Membre
            </NavLink>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div style={{
                background: "white",
                padding: "25px",
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
              }}>
                <h2 style={{
                  fontSize: "24px",
                  color: "#4CAF50",
                  marginBottom: "20px",
                  fontWeight: "600"
                }}>
                  Membres du forum
                </h2>

                {isLoading ? (
                  <div style={{textAlign: "center", padding: "40px"}}>
                    <p>Chargement des membres...</p>
                  </div>
                ) : currentMembers.length > 0 ? (
                  <div className="row">
                    {currentMembers.map((utilisateur) => (
                      <div key={utilisateur.id} className="col-md-6 col-lg-4 mb-4">
                        <div style={{
                          border: "1px solid #e0e0e0",
                          borderLeft: "4px solid #4CAF50",
                          borderRadius: "6px",
                          padding: "15px",
                          height: "100%",
                          backgroundColor: "#ffffff",
                          transition: "box-shadow 0.2s ease"
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.boxShadow = "none";
                        }}>
                          <ProfileInfo utilisateur={utilisateur} />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{
                    textAlign: "center",
                    padding: "40px",
                    background: "#f9f9f9",
                    borderRadius: "8px"
                  }}>
                    <p style={{ color: "#757575", fontSize: "16px" }}>
                      Aucun membre trouvé sur le forum.
                    </p>
                  </div>
                )}

                {/* Compteur de membres */}
                {!isLoading && forumMembers.length > 0 && (
                  <div style={{
                    marginTop: "20px",
                    padding: "10px 15px",
                    backgroundColor: "#f0f7f0",
                    borderRadius: "5px",
                    color: "#4CAF50",
                    display: "inline-block"
                  }}>
                    <strong>{forumMembers.length}</strong> membres ont participé au forum
                  </div>
                )}

                {/* Pagination */}
                {pageCount > 1 && (
                  <div style={{ marginTop: "30px" }}>
                    <ReactPaginate
                      previousLabel={<i className="fa-solid fa-angle-left"></i>}
                      nextLabel={<i className="fa-solid fa-angle-right"></i>}
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      activeLinkClassName={"bg-success border-success text-white"}
                      disabledClassName={"disabled"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer1 />
      <Footer />
    </div>
  );
}

export default Membre;
